import React,{useState, useEffect} from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Javasidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Jclassob(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
 <Sides/>
 <Helmet>
 
 <title>Unlock the Power of Java Objects: A Beginner's Guide to Java Class and Object Tutorial</title>
<meta name="description" content="Discover the power of Java programming with CodeExampler's Java Class and Object tutorial. Our beginner-friendly guide provides real-world examples and engaging exercises to help you master the basics of class and object in Java. Learn to create and use objects, understand prototypes, and explore the differences between class and object. Start your journey towards Java programming excellence today with CodeExampler!" />
<meta name="keywords" content="codeexampler, add two numbers using java class and object tutorial,java class and object examples in hindi,difference between class and object in java beginner programming tutorial" />
<link rel="canonical" href="https://www.codeexampler.com/java-class-and-object" />
</Helmet>

<div className='lg:pl-56'>

    <h1 className="m-4 mh1">Class and Object in Java
</h1>
<div className="first">
        <a href="/java-oops">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-method">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para">1, Java class is a prototype or blueprint that define the form of an object<br/>
2, Java class is constructed by the use of class  keyword<br/>
3, Java class is a collection of an object<br/>
4, Class doesn't gain  space or memory<br/>
5, One main thing is that data, variables, define within a class are known as an <span className="bold"> instance variable</span><br/>
<span className="bold">Important:</span><br/>
If you don’t write  access-modifier  before the class so java give by default  access-modifier  is default<br/>
</p>




<h2 className="headings">Class Syntax in Java:</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
          {"\n"}
          <span className="qwerty-5">Class</span>
          <span className="qwerty-4"> classname</span>          
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
          <span className="qwerty-9">&nbsp;constructors </span>
          {"\n"}
          <span className="qwerty-9">&nbsp;blocks </span>
          {"\n"}
          <span className="qwerty-9">&nbsp;methods </span>
          {"\n"}
          <span className="qwerty-9">&nbsp;nested class </span>
          {"\n"}
          <span className="qwerty-9">&nbsp;fields </span>
          {"\n"}
          <span className="qwerty-3">&#125; </span>      
                      
        </code>
      </pre>        
    </div>




<h2 className="headings">Class Syntax in Java:</h2>
<div
  style={{
    background: "#0f0e33",
    width: "94%",
    marginLeft: "3%",
    paddingLeft: "2%",
    borderRadius: "20px",
  }}
>
  <pre style={{ maxHeight: "500vh" }}>
    <code>
    {"\n"}
    <span className="qwerty-4">access-modifier </span>
    <span className="qwerty-4">Class </span>
    <span className="qwerty-4">ClassName</span>
    {"\n"}
      <span className="qwerty-3">&#123; </span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;Type </span>
  <span className="qwerty-4">variable1;</span>
  {"\n"} 
  <span className="qwerty-2">&nbsp;&nbsp;{`Or`}</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;Type </span>
  <span className="qwerty-4">instance</span>
  <span className="qwerty-4">variable2;</span>
  {"\n"}
  <span className="qwerty-8"> &nbsp;&nbsp; .. </span>
  {"\n"}
  <span className="qwerty-8"> &nbsp;&nbsp; .. </span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;Type </span>
  <span className="qwerty-4">instance</span>
  <span className="qwerty-4">variable N;</span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;{`//Methods`}</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;Type </span>
  <span className="qwerty-4">method1 </span>
  <span className="qwerty-1">(</span>
      <span className="qwerty-10">parameters</span>
      <span className="qwerty-1">) </span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
      {"\n"}
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;{`//Body`}</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;Type </span>
  <span className="qwerty-4">method N</span>
  <span className="qwerty-1">(</span>
      <span className="qwerty-10">parameters</span>
      <span className="qwerty-1">) </span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
      {"\n"}
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;{`//Body`}</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
      {"\n"}
      <span className="qwerty-3">&#125; </span>
      {"\n"}
  


 
  
       
                  
    </code>
  </pre>        
</div>



<h2 className="headings">Class Syntax in Java:</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
          {"\n"}
          <span className="qwerty-5">Class</span>
          <span className="qwerty-4"> school</span>          
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}          
      <span className="qwerty-10">&nbsp;&nbsp;int</span>
      <span className="qwerty-4"> teachers;</span>
      <span className="qwerty-2"> {`// no of teachers`}</span>
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;int</span>
      <span className="qwerty-4"> students;</span>
      <span className="qwerty-2"> {`// no of students`}</span>
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;int</span>
      <span className="qwerty-4"> peon;</span>
      <span className="qwerty-2"> {`// no of poem`}</span>
      
      {"\n"}
          <span className="qwerty-3">&#125; </span>      
                      
        </code>
      </pre>        
    </div>


<h2 className="mt-4 mh2">Following steps to define a class:
</h2>
<p className="mt-4 para">1, We created a class name called school.<br/>
2, You create a few instance variables like- teachers, students, peon.<br/>
3, You also know that class defines a new data type or a new type of data is known as school. <br/>
4, The main thing is that  you will use the school name to declare  as an object type<br/>
5, Class don’t create an actual object because this is only a prototype or blueprint<br/>
</p>
<h2 className="mt-4 mh2">Create an object in java:</h2>
<p className="mt-4 para">1, Object allocates memory<br/>
2, Java object is an instance of the class<br/>
3, New keyword is a keyword  that creates a new java object<br/>
</p>



<h2 className="headings">Syntax for Creating an Object in Java:</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        {"\n"}
        <span className="qwerty-4">ClassName</span>
      <span className="qwerty-3"> object _name</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-5">new </span>
      <span className="qwerty-4">className</span>
      <span className="qwerty-1">();</span>
      {"\n"} 
      <span className="qwerty-2">&nbsp;&nbsp;{`Or`}</span>
      {"\n"}
      <span className="qwerty-4">School</span>
      <span className="qwerty-3"> sch</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-5">new </span>
      <span className="qwerty-4">school</span>
      <span className="qwerty-1">();</span>
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`// create a school object known as sch.`}</span>
      {"\n"}{"\n"}
      
           
                      
        </code>
      </pre>        
    </div>





<h2 className="headings">We Combine both Statements in Two Steps in java:</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        {"\n"}
        <span className="qwerty-4">ClassName</span>
      <span className="qwerty-3"> objectName ;</span>
      <span className="qwerty-2">{`// declare reference to an object`}</span>
      {"\n"} 
      {"\n"}
      <span className="qwerty-4">ObjectName</span>
      <span className="qwerty-3"> sch</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-5">new </span>
      <span className="qwerty-4">ClassName</span>
      <span className="qwerty-1">();</span>
      <span className="qwerty-2">{`// allocate a class object`}</span>
      {"\n"}{"\n"}
             
        </code>
      </pre>        
    </div>




<h2 className="headings">Create object class in java example:</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
          {"\n"}
          <span className="qwerty-5">Class</span>
          <span className="qwerty-4"> school</span>          
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}          
      <span className="qwerty-10">&nbsp;&nbsp;int</span>
      <span className="qwerty-4"> teachers;</span>
      <span className="qwerty-2"> {`// no of teachers`}</span>
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;int</span>
      <span className="qwerty-4"> students;</span>
      <span className="qwerty-2"> {`// no of students`}</span>
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;int</span>
      <span className="qwerty-4"> peon;</span>
      <span className="qwerty-2"> {`// no of poem`}</span>      
      {"\n"}{"\n"}
      <span className="qwerty-4">&nbsp;&nbsp;school</span>
      <span className="qwerty-3"> sch</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-5">new </span>
      <span className="qwerty-4">school</span>
      <span className="qwerty-1">();</span>
      <span className="qwerty-2"> {`// create a school object known as sch`}</span>
      {"\n"} {"\n"} 
      <span className="qwerty-2">&nbsp;&nbsp;{`Or`}</span>
      {"\n"}
      <span className="qwerty-4">&nbsp;&nbsp;school</span>
      <span className="qwerty-3"> sch;</span>

      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;Sch</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-5">new </span>
      <span className="qwerty-4">school</span>
      <span className="qwerty-1">();</span>
      {"\n"}

          <span className="qwerty-3">&#125; </span>      
                      
        </code>
      </pre>        
    </div>


<p className="mt-4 para">1, Sch will be referred to as an instance of a class known as school<br/>
2, Every school object contains its own copies in the form of instance variable such as teachers, students, poem<br/>
3, Dot operator(.) use to link the name of an object with the member name forex:<br/>
</p>




<h2 className="headings">Object Syntax in Java:</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
          {"\n"}
          <span className="qwerty-5">Object</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-4">Member</span> 
          {"\n"} 
      <span className="qwerty-2">&nbsp;&nbsp;{`Or`}</span>
      {"\n"}
      <span className="qwerty-5">School</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-4">Teachers</span>  
          <span className="qwerty-8"> = </span>    
          <span className="qwerty-1">18;</span>    
          {"\n"}{"\n"}
           
                      
        </code>
      </pre>        
    </div>



<p className="mt-4 para">1, This also known as a <span className="bold"> reference variable</span>.<br/>
2, Object put on the left and member put on the right and after assigning the value is 18 or as your choice<br/>
</p>




<h2 className="headings">Q-The Reference Variable in Java Example?</h2>
<div
  style={{
    background: "#0f0e33",
    width: "94%",
    marginLeft: "3%",
    paddingLeft: "2%",
    borderRadius: "20px",
  }}
>
  <pre style={{ maxHeight: "500vh" }}>
    <code>
      {"\n"}
      <span className="qwerty-5">class</span>
      <span className="qwerty-4"> school </span>
      {"\n"}
      <span className="qwerty-3">&#123; </span>
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;int</span>
      <span className="qwerty-4"> teachers;</span>
      <span className="qwerty-2"> {`// no of teachers`}</span>
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;int</span>
      <span className="qwerty-4"> students;</span>
      <span className="qwerty-2"> {`// no of students`}</span>
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;int</span>
      <span className="qwerty-4"> peon;</span>
      <span className="qwerty-2"> {`// no of poem`}</span>
      {"\n"}
      <span className="qwerty-2"> &nbsp;{`//this class declares an object of type school.`}</span>
      
      {"\n"}{"\n"}
                      
       
        <span className="qwerty-7">&nbsp; &nbsp;public </span>
      <span className="qwerty">static </span>
      <span className="qwerty-3">void </span>
      <span className="qwerty-8">main </span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-10">String</span>
      <span className="qwerty-1">[] </span>
      <span className="qwerty-9">args</span>
      <span className="qwerty-1">) </span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
      {"\n"} 
      <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;school</span>
      <span className="qwerty-3"> sch</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-5">new </span>
      <span className="qwerty-4">school</span>
      <span className="qwerty-1">();</span>
      {"\n"} 
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;sch</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-4">teachers</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-1">40;</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;sch</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-4">students</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-1">500;</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;sch</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-4">peon</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-1">20;</span>
      {"\n"}
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`// This dot operator (.) is used to access the member`}</span>
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">"there are "</span>
      <span className="qwerty-8">+</span>
      <span className="qwerty-3"> sch</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-4">teachers</span>
      <span className="qwerty-8">+</span>
      <span className="qwerty-4"> "teachers in this school"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">"there are "</span>
      <span className="qwerty-8">+</span>
      <span className="qwerty-3"> sch</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-4">students</span>
      <span className="qwerty-8">+</span>
      <span className="qwerty-4"> "students in this school"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">"there are "</span>
      <span className="qwerty-8">+</span>
      <span className="qwerty-3"> sch</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-4">peon</span>
      <span className="qwerty-8">+</span>
      <span className="qwerty-4"> "peon in this school"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
     




      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
      {"\n"} 
      <span className="qwerty-3">&#125; </span>
        {"\n"}





   
    </code>
  </pre>        
</div>

<div>
  <h3 className="headings">Output</h3>
  <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
    <pre style={{ maxHeight: '500vh' }}>
      <code className="python hljs">
      {"\n"}
      <span className="qwerty-9">&nbsp;there are 40 teachers in this school</span>
      {"\n"}   
      <span className="qwerty-9">&nbsp;there are 500 students in this school</span>
      {"\n"} 
      <span className="qwerty-9">&nbsp;there are 20 peon in this school</span>
      {"\n"}            
        </code>{"   "}
        </pre>
  </div>
</div>


<p className="mt-4 para">
1, This file call by <span className="bold"> school.java</span> because this program use school class but not call because main() method  inside this class known as an inside School so this file call by inside School.java only<br/>
2, This is not compulsory both class school and inside School put in same source file .you could put each class in a different file known as school.java and insideSchool.java<br/>
3, To run this program by executing inside the school.class <br/>
</p>



<h2 className="headings">Q-Create 2 Object in Java class Example?</h2>
<div
  style={{
    background: "#0f0e33",
    width: "94%",
    marginLeft: "3%",
    paddingLeft: "2%",
    borderRadius: "20px",
  }}
>
  <pre style={{ maxHeight: "500vh" }}>
    <code>
      {"\n"}
      <span className="qwerty-5">class</span>
      <span className="qwerty-4"> school </span>
      {"\n"}
      <span className="qwerty-3">&#123; </span>
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;int</span>
      <span className="qwerty-4"> teachers;</span>
      <span className="qwerty-2"> {`// no of teachers`}</span>
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;int</span>
      <span className="qwerty-4"> students;</span>
      <span className="qwerty-2"> {`// no of students`}</span>
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;int</span>
      <span className="qwerty-4"> peon;</span>
      <span className="qwerty-2"> {`// no of poem`}</span>
      {"\n"}
      <span className="qwerty-2"> &nbsp;{`//this class declares an object of type school.`}</span>
      
      {"\n"}{"\n"}
                      
       
        <span className="qwerty-7">&nbsp; &nbsp;public </span>
      <span className="qwerty">static </span>
      <span className="qwerty-3">void </span>
      <span className="qwerty-8">main </span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-10">String</span>
      <span className="qwerty-1">[] </span>
      <span className="qwerty-9">args</span>
      <span className="qwerty-1">) </span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
      {"\n"} 
      <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;school</span>
      <span className="qwerty-3"> sch1</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-5">new </span>
      <span className="qwerty-4">school</span>
      <span className="qwerty-1">();</span>
      {"\n"} 
      <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;school</span>
      <span className="qwerty-3"> sch2</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-5">new </span>
      <span className="qwerty-4">school</span>
      <span className="qwerty-1">();</span>
      {"\n"} 
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`//Sch1 and sch2 Both are different objects`}</span>{"\n"}
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`//assigns value inside the sch1 fields`}</span>
      {"\n"}{"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;sch1</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-4">teachers</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-1">40;</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;sch1</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-4">students</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-1">500;</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;sch1</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-4">peon</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-1">20;</span>
      {"\n"}

      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`//assigns value inside the sch2 fields`}</span>
      {"\n"}{"\n"}

      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;sch2</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-4">teachers</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-1">20;</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;sch2</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-4">students</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-1">250;</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;sch2</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-4">peon</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-1">10;</span>
      {"\n"}
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`// This dot operator (.) is used to access the member`}</span>
      {"\n"}{"\n"}
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`//sch1`}</span>
      {"\n"}{"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">"there are "</span>
      <span className="qwerty-8">+</span>
      <span className="qwerty-3"> sch1</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-4">teachers</span>
      <span className="qwerty-8">+</span>
      <span className="qwerty-4"> "teachers in this school 1"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">"there are "</span>
      <span className="qwerty-8">+</span>
      <span className="qwerty-3"> sch1</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-4">students</span>
      <span className="qwerty-8">+</span>
      <span className="qwerty-4"> "students in this school 1"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">"there are "</span>
      <span className="qwerty-8">+</span>
      <span className="qwerty-3"> sch1</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-4">peon</span>
      <span className="qwerty-8">+</span>
      <span className="qwerty-4"> "peon in this school 1"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
     




      {"\n"}{"\n"}
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`//sch2`}</span>
      {"\n"}{"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">"there are "</span>
      <span className="qwerty-8">+</span>
      <span className="qwerty-3"> sch2</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-4">teachers</span>
      <span className="qwerty-8">+</span>
      <span className="qwerty-4"> "teachers in this school 2"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">"there are "</span>
      <span className="qwerty-8">+</span>
      <span className="qwerty-3"> sch2</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-4">students</span>
      <span className="qwerty-8">+</span>
      <span className="qwerty-4"> "students in this school 2"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">"there are "</span>
      <span className="qwerty-8">+</span>
      <span className="qwerty-3"> sch2</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-4">peon</span>
      <span className="qwerty-8">+</span>
      <span className="qwerty-4"> "peon in this school 2"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
     




      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
      {"\n"} 
      <span className="qwerty-3">&#125; </span>
        {"\n"}





   
    </code>
  </pre>        
</div>

<div>
  <h3 className="headings">Output</h3>
  <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
    <pre style={{ maxHeight: '500vh' }}>
      <code className="python hljs">
      {"\n"}
      <span className="qwerty-9">&nbsp;there are 40 teachers in this school 1</span>
      {"\n"}   
      <span className="qwerty-9">&nbsp;there are 500 students in this school 1</span>
      {"\n"} 
      <span className="qwerty-9">&nbsp;there are 20 peon in this school 1</span>
      {"\n"}  {"\n"}  
      <span className="qwerty-9">&nbsp;there are 20 teachers in this school 2</span>
      {"\n"}   
      <span className="qwerty-9">&nbsp;there are 250 students in this school 2</span>
      {"\n"} 
      <span className="qwerty-9">&nbsp;there are 10 peon in this school 2 </span>
      {"\n"}            
        </code>{"   "}
        </pre>
  </div>
</div>


  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/java-oops">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-method">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Jclassob;